import React from 'react'
import "./Header.css"

function Header() {
  return (
    <div className='header'>
      <div className="header-contants">
        <h2>Order your favorite food here</h2>
        <p>
          Craving something delicious? Browse our menu and find your favorite dishes made with fresh ingredients and bursting with flavor. Whether you're in the mood for a quick bite or a hearty meal, we've got something for everyone. Order now and satisfy your hunger!
        </p>
        <button>View Menu</button>
      </div>
    </div>
  )
}

export default Header
